import UserPayloadInterface from '../../../../../../../../../../types/users/UserPayload.interface';

export default interface UserFormInterface extends UserPayloadInterface {}

export const defaultValues: UserFormInterface = {
  email: '',
  fullName: '',
  roles: [],
};
